import React from "react";
import { map } from "lodash";
import { Link } from "react-router-dom";

const SimpleList = ({ items, hover, component }) => {
  let _classes = ["list-group-item"];
  if (hover) {
    _classes.push("hover");
  }
  return (
    <div className="list-group">
      {map(items, (item, index) => {
        if (item.to) {
          return (
            <Link to={item.to} className={_classes.join(" ")}>
              {item.text}
            </Link>
          );
        } else {
          return (
            <a
              onClick={() => {
                if (item.onClick) {
                  item.onClick(component);
                }
              }}
              className={_classes.join(" ")}
            >
              {item.text(component.props)}
            </a>
          );
        }
      })}
    </div>
  );
};

export default SimpleList;



// WEBPACK FOOTER //
// ./src/_components/UI/SimpleList/index.js